import { useEffect, useState } from "react";
import {
  fetchResources,
  downloadResourceMasterExcel,
} from "../Api/ResourceList";
import { Button, Container, Table, Row, Col } from "react-bootstrap";
import { FaDownload, FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import { FaPencilAlt } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";
import { Base_URL } from "../url";
import axios from "axios";
import "../Styling/AllTables.css";

// 🔹 Import all master dropdown APIs from same file
import {
  fetchRoles,
  fetchDepartments,
  fetchOfficeCodes,
  fetchEmployeeTypes,
  fetchStations,
} from "../Api/ResourceMaster";

const ResourceList = () => {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusReasonFilter, setStatusReasonFilter] = useState("all");

  // 🔹 Filters
  const [statusFilter, setStatusFilter] = useState("active");

  const [roleFilter, setRoleFilter] = useState("all");
  const [departmentFilter, setDepartmentFilter] = useState("all");
  const [officeFilter, setOfficeFilter] = useState("all");
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [EmployeeTypeFilter, setEmployeeTypeFilter] = useState("all");
  const [stations, setStations] = useState([]);
  const [stationFilter, setStationFilter] = useState("all");

  // 🔹 Master data lists
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [offices, setOffices] = useState([]);

  const navigate = useNavigate();
  const { user } = useAuth();

  // Search bar
  const [nameSearch, setNameSearch] = useState("");

  // === Load masters ===
  const loadRoles = async () => {
    try {
      const data = await fetchRoles(user?.organisationId);
      setRoles(data || []);
    } catch (error) {
      toast.error("Error fetching roles");
    }
  };

  const loadDepartments = async () => {
    try {
      const data = await fetchDepartments(user?.organisationId);
      setDepartments(data || []);
    } catch (error) {
      toast.error("Error fetching departments");
    }
  };

  const loadOffices = async () => {
    try {
      const data = await fetchOfficeCodes(user?.organisationId);
      setOffices(data || []);
    } catch (error) {
      toast.error("Error fetching office codes");
    }
  };

  // === Load resources ===
  const loadResources = async () => {
    try {
      const data = await fetchResources(user?.organisationId);
      console.log("Fetched Resources:", data);
      setResources(data || []);
    } catch (error) {
      toast.error(`Error Fetching Resources: ${error.message}`);
    }
  };
  const loadEmployeeTypes = async () => {
    try {
      const data = await fetchEmployeeTypes();
      setEmployeeTypes(data || []);
    } catch (error) {
      toast.error("Error fetching employee types");
    }
  };

  const loadStations = async () => {
    try {
      const data = await fetchStations(user?.organisationId);
      setStations(data || []);
    } catch (error) {
      toast.error("Error fetching stations");
    }
  };

  useEffect(() => {
    loadResources();
    loadRoles();
    loadDepartments();
    loadOffices();
    loadEmployeeTypes();
    loadStations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

const handleDownloadExcel = async () => {
  setLoading(true);
  try {
const filters = {
  orgId: user?.organisationId,       // → OrgId ✓
  status: statusFilter,              // → Status ✓
  role: roleFilter,                  // → Role ✓
  department: departmentFilter,      // → Department ✓
  office: officeFilter,              // → Office ✓
  employeeType: EmployeeTypeFilter,  // → EmployeeType ✓
  station: stationFilter,            // → Station ✓
  statusReason: statusReasonFilter,  // → StatusReason ✓
  name: nameSearch,                  
};
    console.log("Filters sent:", filters);

    const response = await downloadResourceMasterExcel(filters);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Resource_Master_Data.xlsx");
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      link.remove();
    }, 100);

    toast.success("Filtered data downloaded!");
  } catch (error) {
    toast.error(error.message);
  } finally {
    setLoading(false);
  }
};

  const handleAddResource = () => {
    navigate("/resource-master");
  };

  const handleInactive = async (id) => {
    try {
      const res = await axios.put(
        `${Base_URL}/Resource/UpdateActiveStauts/id?id=${id}`,
      );
      if (res.status === 200) {
        toast.success(`Resource Made Inactive Successfully`);
        loadResources();
      } else {
        toast.error("Error Making Resource Inactive");
      }
    } catch (error) {
      toast.error("Error Making Resource Inactive");
    }
  };

  // === Apply filters: status + role + department + office ===
  const filteredResources = resources.filter((resource) => {
    const statusMatch =
      statusFilter === "all" ||
      (statusFilter === "active" && resource.active) ||
      (statusFilter === "inactive" && !resource.active);

    const roleMatch = roleFilter === "all" || resource.role === roleFilter;

    const EmployeeTypeMatch =
      EmployeeTypeFilter === "all" ||
      resource.employeeType === EmployeeTypeFilter;
    const departmentMatch =
      departmentFilter === "all" || resource.department === departmentFilter;

    const stationMatch =
      stationFilter === "all" || resource.stationNames?.includes(stationFilter);
    const officeMatch =
      officeFilter === "all" || resource.officeName === officeFilter;

    const statusReasonMatch =
      statusReasonFilter === "all" ||
      resource.statusReason === statusReasonFilter;

    // 🔹 NAME SEARCH MATCH
    const nameMatch =
      nameSearch.trim() === "" ||
      resource.name?.toLowerCase().includes(nameSearch.toLowerCase());

    return (
      statusMatch &&
      roleMatch &&
      departmentMatch &&
      officeMatch &&
      statusReasonMatch &&
      nameMatch &&
      EmployeeTypeMatch &&
      stationMatch
    );
  });

  return (
    <div className="main-content expand">
      <Container fluid className="list-container">
        <div className="header-background">
          {/* Left: Heading */}
          <div className="heading-name">
            <h1 className="header-list-title">Resource List</h1>
          </div>

          {/* Right: Buttons side by side */}
          <div>
            {/* Add Resource Button */}
            <Row>
              <Col className="d-flex justify-content-start">
                <button
                  className="gradient-btn green-btn"
                  onClick={handleAddResource}
                >
                  <span>
                    <FaPlus style={{ marginRight: "8px" }} />
                    Add Resource
                  </span>
                </button>
              </Col>
              <Col className="d-flex justify-content-start">
                {/* Download Button */}
                <button
                  className="gradient-btn"
                  onClick={handleDownloadExcel}
                  disabled={loading}
                >
                  {loading ? (
                    "Downloading..."
                  ) : (
                    <>
                      <span>
                        <FaDownload style={{ marginRight: "8px" }} />
                        Download Data
                      </span>
                    </>
                  )}
                </button>
              </Col>
            </Row>
          </div>
        </div>

        {/* ///////////// */}
        {/* 🔍 Name Search Bar */}
        <div style={{ marginBottom: "12px" }}>
          <div style={{ position: "relative", width: "250px" }}>
            <FaSearch
              style={{
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
                color: "#888",
                zIndex: 2,
                pointerEvents: "none",
              }}
            />
            <input
              type="text"
              placeholder="Search by Name"
              value={nameSearch}
              onChange={(e) => setNameSearch(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 8px 8px 30px", // left padding for icon
                borderRadius: "12px",
                border: "1px solid #ccc",
                outline: "none",
                transition: "all 0.2s ease",
                backgroundColor: "#fff",
                position: "relative", // keeps stacking context
                zIndex: 1,
              }}
              // 🔹 Pop out effect on hover
              onMouseEnter={(e) => {
                e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.2)";
                e.target.style.transform = "scale(1.03)";
                e.target.style.borderColor = "#6a6972ff";
              }}
              onMouseLeave={(e) => {
                e.target.style.boxShadow = "none";
                e.target.style.transform = "scale(1)";
                e.target.style.borderColor = "#ccc";
              }}
            />
          </div>
        </div>

        {/* Table ALWAYS rendered; only body content changes */}
        <div className="table-wrapper">
          <div className="table-scroll-container">
            <Table bordered hover className="data-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Actions</th>

                  {/* Status with dropdown in header */}
                  <th>
                    Status <br />
                    <select
                      className="table-header-select"
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                    >
                      <option value="all">All</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </th>
                  <th>
                    Status Reason <br />
                    <select
                      className="table-header-select"
                      value={statusReasonFilter}
                      onChange={(e) => setStatusReasonFilter(e.target.value)}
                    >
                      <option value="all">All</option>
                      <option value="Prohibition">Prohibition</option>
                      <option value="Confirmation">Confirmation</option>
                      <option value="Resigned">Resigned</option>
                      <option value="Left">Left</option>
                    </select>
                  </th>

                  <th>Resource ID</th>
                  <th>Name</th>
                  <th>DOB</th>

                  {/* Role with dropdown in header */}
                  <th>
                    ROLE <br />
                    <select
                      className="table-header-select"
                      value={roleFilter}
                      onChange={(e) => setRoleFilter(e.target.value)}
                    >
                      <option value="all">All</option>
                      {roles.map((role, index) => (
<option value={role.description}>
  {role.description}
</option>
                      ))}
                    </select>
                  </th>

                  {/* Department with dropdown in header */}
                  <th>
                    Department <br />
                    <select
                      className="table-header-select"
                      value={departmentFilter}
                      onChange={(e) => setDepartmentFilter(e.target.value)}
                    >
                      <option value="all">All</option>
                      {departments.map((dept, index) => (
<option value={dept.description}>
  {dept.description}
</option>
                      ))}
                    </select>
                  </th>

                  <th>Official Email ID</th>
                  <th>Personal Email ID</th>
                  <th>Company Name</th>

                  {/* Office Name with dropdown in header */}
                  <th>
                    Office Name <br />
                    <select
                      className="table-header-select"
                      value={officeFilter}
                      onChange={(e) => setOfficeFilter(e.target.value)}
                    >
                      <option value="all">All</option>
                      {offices.map((office, index) => (
<option value={office.description}>
  {office.description}
</option>
                      ))}
                    </select>
                  </th>

                  <th>
                    Employee Type <br />
                    <select
                      className="table-header-select"
                      value={EmployeeTypeFilter}
                      onChange={(e) => setEmployeeTypeFilter(e.target.value)}
                    >
                      <option value="all">All</option>
                      {employeeTypes.map((type, index) => (
<option value={type.description}>
  {type.description}
</option>
                      ))}
                    </select>
                  </th>
                  <th>Date Of Joining</th>
                  <th>Confirmation Date</th>
                  <th>
                    Station <br />
                    <select
                      className="table-header-select"
                      value={stationFilter}
                      onChange={(e) => setStationFilter(e.target.value)}
                    >
                      <option value="all">All</option>
                      {stations.map((station, index) => (
<option value={station.name}>
  {station.name}
</option>
                      ))}
                    </select>
                  </th>
                  <th>Fathers Name</th>
                  <th>Marital Status</th>
                  <th>Spouse Name</th>
                  <th>Phone No</th>
                  <th>PAN No</th>
                  <th>Aadhar No</th>
                  <th>Blood Group</th>
                  <th>UAN No</th>
                  {/* <th>URL Aadhar Card</th>
                  <th>URL PAN Card</th> */}
                  <th>Emergency Contact Name</th>
                  <th>Emergency Contact Relation</th>
                  <th>Emergency Contact Phone No</th>
                  <th>Payment Group</th>
                  <th>Bank Name</th>
                  <th>Account No.</th>
                  <th>IFSC Code</th>
                  <th>Cost Center</th>
                  <th>Current Address</th>
                  <th>Permanent Address</th>
                  <th>Left Date</th>
                </tr>
              </thead>

              <tbody>
                {filteredResources.length > 0 ? (
                  filteredResources.map((resource, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>

                      <td style={{ display: "flex", gap: "4px" }}>
                        <Button
                          variant="outline-primary"
                          title="Edit Resource"
                          onClick={() =>
                            navigate(`/updateResource/${resource.resourceId}`)
                          }
                        >
                          <FaPencilAlt />
                        </Button>
                        <Button
                          variant="outline-danger"
                          title="Make Resource Inactive"
                          disabled={resource.active === false}
                          onClick={() => handleInactive(resource?.resourceId)}
                        >
                          <FaTimes />
                        </Button>
                      </td>

                      <td
                        style={{
                          color: resource?.active ? "green" : "red",
                          fontWeight: 600,
                        }}
                      >
                        {resource?.active ? "Active" : "Inactive"}
                      </td>
                      <td>{resource?.statusReason}</td>
                      <td>{resource.resourceId}</td>
                      <td>{resource.name}</td>
                      <td>{moment(resource.dob).format("L")}</td>
                      <td>{resource.role}</td>
                      <td>{resource.department}</td>
                      <td>{resource.emailId}</td>
                      <td>{resource.personalEmailId}</td>
                      <td>{resource.companyName}</td>
                      <td>{resource.officeName}</td>
                      <td>{resource.employeeType}</td>
                      <td>{moment(resource.doj).format("L")}</td>
                      <td>{moment(resource?.confirmationDate).format("L")}</td>
                      <td>{resource.stationNames}</td>
                      <td>{resource.fathersName}</td>
                      <td>{resource.maritalStatus}</td>
                      <td>{resource.spouseName}</td>
                      <td>{resource.phoneNumber}</td>
                      <td>{resource.panNumber}</td>
                      <td>{resource.aadharNumber}</td>
                      <td>{resource.bloodGroup}</td>
                      <td>{resource.uanNumber}</td>
                      {/* <td>{resource.urlAadharCard}</td>
                      <td>{resource.urlPanCard}</td> */}
                      <td>{resource.emergencyContactName}</td>
                      <td>{resource.emergencyContactRelation}</td>
                      <td>{resource.emergencyContactPhoneNumber}</td>
                      <td>{resource.paymentGroup}</td>
                      <td>{resource.bankName}</td>
                      <td>{resource.accountNo}</td>
                      <td>{resource.ifscCode}</td>
                      <td>{resource.costCenter}</td>
                      <td>
                        {resource.address1},{resource.address2},
                        {resource.address3}
                      </td>
                      <td>
                        {resource.address4},{resource.address5},
                        {resource.address6}
                      </td>
                      <td>
                        {resource?.leftDate
                          ? moment(resource.leftDate).format("DD-MMM-YYYY")
                          : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    {/* 30 columns total → colspan=30 */}
                    <td
                      colSpan={30}
                      style={{
                        textAlign: "center",
                        fontWeight: 600,
                        padding: "16px",
                      }}
                    >
                      No resources found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ResourceList;
